export default __webpack_public_path__ + "static/media/kendo.9686c071.jpg";